
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ChatIconComponent } from "./chat-icon.svg";

export const ChatIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ChatIconComponent {...props} />;
};
